import React, { createContext, useContext, useState, useCallback } from 'react';
import { Box, CircularProgress, useTheme } from '@mui/material';

const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
    const [loadingStates, setLoadingStates] = useState({});
    const [globalLoading, setGlobalLoading] = useState(false);
    const theme = useTheme();

    const startLoading = useCallback((key = 'global') => {
        if (key === 'global') {
            setGlobalLoading(true);
        } else {
            setLoadingStates(prev => ({ ...prev, [key]: true }));
        }
    }, []);

    const stopLoading = useCallback((key = 'global') => {
        if (key === 'global') {
            setGlobalLoading(false);
        } else {
            setLoadingStates(prev => ({ ...prev, [key]: false }));
        }
    }, []);

    const isLoading = useCallback((key = 'global') => {
        if (key === 'global') return globalLoading;
        return loadingStates[key] || false;
    }, [globalLoading, loadingStates]);

    return (
        <LoadingContext.Provider value={{ startLoading, stopLoading, isLoading }}>
            {globalLoading && (
                <Box
                    sx={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.7)',
                        zIndex: 9999,
                    }}
                >
                    <CircularProgress 
                        size={60} 
                        sx={{ color: theme.palette.primary.main }}
                    />
                </Box>
            )}
            {children}
        </LoadingContext.Provider>
    );
};

export const useLoading = () => {
    const context = useContext(LoadingContext);
    if (!context) {
        throw new Error('useLoading must be used within a LoadingProvider');
    }
    return context;
};

export default LoadingContext; 